import {
  IApiSuccessWrapper,
  IExportStatus,
  IHCAMCAClassLocationTableObject
} from '$/types'
import { apiSlice } from 'app/services/api'

const SYSTEM_SCOPE_ID_PARAM_NAME = 'systemScopeId'

export interface IGetHMCATableQueryParams {
  systemScopeId: string
  routeIds: string[]
  classification: string[]
  fromDate: string | undefined
  toDate: string | undefined
}

export const hmcaConsequenceAreaDataTableApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getHMCAConsequenceAreaTable: build.query<
      IHCAMCAClassLocationTableObject,
      IGetHMCATableQueryParams
    >({
      query: ({
        systemScopeId,
        classification,
        routeIds,
        fromDate,
        toDate
      }) => ({
        method: 'POST',
        url: '/consequencearea',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId
        },
        body: {
          classification,
          routeIds,
          fromDate,
          toDate
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IHCAMCAClassLocationTableObject
      }
    }),
    addHMCAConsequenceAreaTableExportJob: build.mutation<
      IExportStatus,
      IGetHMCATableQueryParams
    >({
      query: ({
        systemScopeId,
        classification,
        routeIds,
        fromDate,
        toDate
      }) => ({
        method: 'POST',
        url: '/consequencearea/export',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId
        },
        body: {
          classification,
          routeIds,
          fromDate,
          toDate
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    })
  })
})

export const {
  useGetHMCAConsequenceAreaTableQuery,
  useAddHMCAConsequenceAreaTableExportJobMutation
} = hmcaConsequenceAreaDataTableApi
